import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../Header';
import Header2 from '../Header2';
import Footer from '../Footer';
import { fetchActivePromotions } from '../../api/starviewApi';
import './Offers.css';

const DESKTOP_BREAKPOINT = 900;

function formatDiscount(promo) {
  return promo.discount_type === 'percent'
    ? `${promo.discount_value}% OFF`
    : `$${(promo.discount_value / 100).toFixed(0)} OFF`;
}

export default function Offers() {
  const [isDesktop, setIsDesktop] = useState(false);
  const [promotions, setPromotions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [copiedCode, setCopiedCode] = useState('');

  useEffect(() => {
    const check = () => setIsDesktop(window.innerWidth >= DESKTOP_BREAKPOINT);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  useEffect(() => {
    let cancelled = false;
    fetchActivePromotions()
      .then((data) => { if (!cancelled) setPromotions(data); })
      .catch((err) => { if (!cancelled) setError(err.message); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const handleCopy = (code) => {
    navigator.clipboard?.writeText(code);
    setCopiedCode(code);
    setTimeout(() => setCopiedCode(''), 1800);
  };

  return (
    <div className="offers-root">
      <Header />
      {isDesktop && <Header2 />}

      <section className="offers-hero">
        <span className="offers-eyebrow">Offers & Discounts</span>
        <h1 className="offers-title">Real Sales, Real Savings</h1>
        <p className="offers-subtitle">Every code below is live and enforced automatically at checkout — no fine print, no fake percentages.</p>
      </section>

      <section className="offers-list-section">
        {loading && <p className="offers-status">Loading current offers…</p>}
        {!loading && error && <p className="offers-status">{error}</p>}
        {!loading && !error && promotions.length === 0 && (
          <p className="offers-status">No active promotions right now — check back soon.</p>
        )}
        {!loading && !error && promotions.length > 0 && (
          <div className="offers-grid">
            {promotions.map((promo) => (
              <div key={promo.promotion_id} className="offer-card">
                <span className="offer-badge">{formatDiscount(promo)}</span>
                <h2 className="offer-title">{promo.title}</h2>
                <p className="offer-desc">{promo.description}</p>
                <button className="offer-code-btn" onClick={() => handleCopy(promo.code)}>
                  <span>{promo.code}</span>
                  <span className="offer-copy-label">{copiedCode === promo.code ? 'Copied!' : 'Copy'}</span>
                </button>
                {promo.valid_until && (
                  <p className="offer-expiry">Valid through {new Date(promo.valid_until).toLocaleDateString()}</p>
                )}
              </div>
            ))}
          </div>
        )}
        <div className="offers-cta-row">
          <Link to="/Showtimes" className="offers-cta">Use a Code at Checkout</Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
